import { createContext } from 'react';
export const colorSchemeInitialContextValue = {
    variant: 'light',
};
export const ColorSchemeContext = createContext(colorSchemeInitialContextValue);
